export default {
    productDetail: '项目详情',
    faultStatistic: '故障统计',
    incomeAnalysis: '收益分析',
    productSeries: '项目序列号',
    masterInfo: '业主信息',
    productLeader: '项目负责人',
    maintenanceInfo: '运维人员信息',
    deviceType: '设备类型',
    batteryType: '电池类型',
    devicePlace: '设备地点',
    barYAxisTitle: '收益（元）',
    discharge: '放电',
    running: '运行',
    normal: '正常',
    on: '开机',
    home: '首页',
    more: '更多',
    username: '姓名',
    telephone: '电话'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/topo.js